// extracted by mini-css-extract-plugin
export var active = "_b1-7";
export var blink = "_b1-8";
export var dropDownSelector = "_b1-4";
export var dropDownWrapper = "_b1-3";
export var fakeCursor = "_b1-6";
export var fontSizeButton = "_b1-9";
export var formQuillEditor = "_b1-0";
export var pressed = "_b1-a";
export var qlBlank = "_b1-1";
export var textFormattingToolbar = "_b1-2";
export var textToolbarOption = "_b1-5";